import { render, staticRenderFns } from "./OnboardingImportSimpleMethodModal.vue?vue&type=template&id=d88fe252&scoped=true"
import script from "./OnboardingImportSimpleMethodModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportSimpleMethodModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportSimpleMethodModal.vue?vue&type=style&index=0&id=d88fe252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88fe252",
  null
  
)

export default component.exports